/* @flow strict */

import * as React from 'react';
import Panel from './../../components/panel';
import EditLanguageModal from './modals/language';
import t from '/client/src/utils/i18nCheckKey';
import { _lng } from '/client/src/constants';

const PropsType = {
  context: {}
};

const SettingsPageLang = ({ context }: PropsType): React.Element<typeof React.Fragment> => {
  const [isOpen, handleToggleModal] = React.useState(false);

  return (
    <>
      <Panel
        className='SettingsPagePayment-payment'
        title={
          <div>
            {t('Language')}

            <span
              className='panel-title-action  btn'
              onClick={(): any => handleToggleModal(true)}
            >Edit</span>
          </div>
        }
        headerClassName='panel-heading-green'
      >
        <div className="row">
          <div className="col-lg-6">
            <ul className='table'>
              <li>
                <span className='key'>{t('Language')}</span>
                <span className='value'>{_.get(_lng[context.profileCurrent.lang], 'label', '')}</span>
              </li>
            </ul>
          </div>
        </div>
      </Panel>

      {isOpen ?
        <EditLanguageModal
          isOpen={isOpen}
          handleToggleModal={handleToggleModal}
        /> : null
      }
    </>
  );
};

export default SettingsPageLang;
